import React from "react";
import Title from "../../ui/Title";

const Population = () => {
  return (
    <div className="text-softBlack leading-loose text-base font-normal">
      <Title
        title="The growing aging population in the Nooraverse"
        className="mb-6"
      />

      <div className="space-y-4 text-softBlack leading-loose text-base font-normal">
        <p>
          The demographic trends in all the countries we work in suggest a shift
          towards low mortality, low fertility societies, which indicate a rise
          in the number of people who would need care, but fewer potential
          caregivers in the family. This has a direct impact on models such as
          ours that depend on family caregiving.
        </p>
        <p>
          Below are key demographic trends in the countries we work in,
          indicating a shift towards a low-mortality, low-fertility society:
        </p>
      </div>

      <div id="india-demographics" className="mb-8 scroll-mt-24 mt-8">
        <h3 className="font-bold text-black mb-4">India</h3>
        <ul className="list-disc list-outside space-y-2 ml-6">
          <li>
            <a
              href="https://www.population-trends-asiapacific.org/data/population-ageing/IND"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue underline"
            >
              Data
            </a>{" "}
            from the United Nations Economic and Social Commission for Asia and
            the Pacific (UNESCAP) shows that in 2020, there were approximately
            142.3 million people above the age of 60 (10.7 percent of the
            population), and in 2050, this is projected to increase to 347.5
            million (20.8 percent of the population).
          </li>
          <li>
            The total fertility rate in India is also on a downward trend, from
            2.05 in 2020 to a projected 1.78 in 2050.
          </li>
        </ul>
      </div>

      <div id="bangladesh-demographics" className="mb-8 scroll-mt-24">
        <h3 className="font-bold text-black mb-4">Bangladesh</h3>
        <ul className="list-disc list-outside space-y-2 ml-6">
          <li>
            According to{" "}
            <a
              href="https://www.population-trends-asiapacific.org/data/population-ageing/BGD"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue underline"
            >
              UNESCAP data,
            </a>{" "}
            in 2020, there were approximately 14.6 million people above the age
            of 60 (8.8 percent of the population), and in 2050, this is
            projected to increase to 43.3 million (21.3 percent of the entire
            population).
          </li>
          <li>
            Total fertility is also on a downward trend. In 2020 it was2.0 and
            itsprojected to be 1.75 in 2050.
          </li>
        </ul>
      </div>

      <div id="indonesia-demographics" className="mb-8 scroll-mt-24">
        <h3 className="font-bold text-black mb-4">Indonesia</h3>
        <ul className="list-disc list-outside space-y-2 ml-6">
          <li>
            In 2020, according to{" "}
            <a
              href="https://www.population-trends-asiapacific.org/data/population-ageing/IDN"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue underline"
            >
              UNESCAP data
            </a>
            , there were approximately 28.5 million people above the age of 60
            (10.5 percent of the population), and in 2050, this is projected to
            increase to 64.8 million, (20.5 percent of the entire population).
          </li>
          <li>
            The total fertility rate is also on a decline from 2.19 in 2020 to a
            projected 1.86 in 2050.
          </li>
        </ul>
      </div>

      <div id="nepal-demographics" className="mb-8 scroll-mt-24">
        <h3 className="font-bold text-black mb-4">Nepal</h3>
        <ul className="list-disc list-outside space-y-2 ml-6">
          <li>
            According to{" "}
            <a
              href="https://www.population-trends-asiapacific.org/data/population-ageing/NPL"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue underline"
            >
              UNESCAP data
            </a>
            , in 2020, there were approximately 2.6 million people above the age
            of 60, (9 percent of the population), and in 2050, this is projected
            to increase to 5.7 million (15.4 percent of the entire population).
          </li>
          <li>
            The total fertility rate is also on a downward trend. It was 2.05 in
            2020 and it is projected to reach 1.76 in 2050.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Population;
